import * as ReportActions from './reports.actions';

export const REPORTS_STATE_NAME = 'reports';

const INITIAL_STATE = {
  tableauReportList: [],
  errorMessage: null,
  createUserError: null,
  requestingTrustedTicket: false,
  trustedTicketError: null,
  trustedTicket: null
};

export default (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case ReportActions.CONSUME_TRUSTED_TICKET:
      return {...state, trustedTicket: null};
    case ReportActions.REQUEST_TRUSTED_TICKET:
      return {...state, trustedTicket: null, requestingTrustedTicket: true, trustedTicketError: null};
    case ReportActions.REQUEST_TRUSTED_TICKET_SUCCESS:
      return {...state, trustedTicket: payload.ticket, requestingTrustedTicket: false, trustedTicketError: null};
    case ReportActions.REQUEST_TRUSTED_TICKET_FAILED:
      return {...state, trustedTicket: payload.ticket, requestingTrustedTicket: false, trustedTicketError: payload.error};
    case ReportActions.REQUEST_TABLEAU_REPORTS_SUCCESS:
      return {...state, tableauReportList: payload.reportsList, errorMessage: null};
    case ReportActions.REQUEST_TABLEAU_REPORTS_FAILED:
      return {...state, errorMessage: payload.error};
    case ReportActions.CREATE_TABLEAU_USER_FAILED:
      return {...state, createUserError: payload.error};
    default:
      return state;
  }
};
